export const namespace = 'https://delivery.elliscoffee.com';
